import React, { useState } from 'react'
import Layout from 'src/features/Layout'
import Stepper from './Stepper'
import { useDispatch } from 'react-redux'
import { selectAccount } from './ducks'

import Step1 from './Step1'
import Step2 from './Step2'
import Success from './Success'

export default function Index() {
  const dispatch = useDispatch()
  const [step, setStep] = useState(1)

  const onSelectAccount = (acc) => {
    dispatch(selectAccount(acc))
    setStep(2)
  }

  return (
    <Layout>
      <Stepper step={step} setStep={setStep} />
      {step === 1 && <Step1 actions={[onSelectAccount]} />}
      {step === 2 && <Step2 setStep={setStep} />}
      {step === 3 && <Success setStep={setStep} />}
    </Layout>
  )
}
